module.exports = __webpack_public_path__ + "static/media/_DSC6112.e23c71fc.jpg";